import { Modal, ModalContent, ModalOverlay, Image } from '@chakra-ui/react'
import React, { useEffect, useState, useRef } from 'react'
import QRCode from 'qrcode'

export const QRCodeModal = ({ qrCode, isOpen, onClose }) => {
  const initialRef = useRef(null)
  const finalRef = useRef(null)
  const [qrCodeSrc, setQrCodeSrc] = useState('')

  useEffect(() => {
    if (qrCode && isOpen) {
      QRCode.toDataURL(qrCode, { margin: 2, width: 400 })
        .then(url => {
          setQrCodeSrc(url)
        })
        .catch(err => {
          console.error('Error generating QR code', err)
        })
    }
  }, [qrCode, isOpen])

  return (
    <Modal
      initialFocusRef={initialRef}
      finalFocusRef={finalRef}
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={true}
      autoFocus={false}
      isCentered
    >
      <ModalOverlay />
      <ModalContent
        width={{ sm: '280px', lg: '400px' }}
        height={{ sm: '280px', lg: '400px' }}
      >
        {qrCodeSrc && (
          <Image
            src={qrCodeSrc}
            alt='Ticket QR Code'
            borderRadius='24px'
          />
        )}
      </ModalContent>
    </Modal>
  )
}